import {
    ROOT,
    GET_CHAIN_RATE_CATEGORY_LIST,
    CREATE_CHAIN_RATE_CATEGORY,
    UPDATE_CHAIN_RATE_CATEGORY,
    GET_CHAIN_RATE_CATEGORY_DETAIL,
    RATE_CHAIN_CATEGORY_CHANGE_STATUS,
    DELETE_CHAIN_CATEGORY
} from "@/_helpers/constant.js";
import { requestOptions, handleResponse } from "@/_helpers";

//#region list of rooms
function getRateCategoryList(data) {
    return fetch(ROOT + GET_CHAIN_RATE_CATEGORY_LIST, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function getDetail(id) {
    return fetch(ROOT + GET_CHAIN_RATE_CATEGORY_DETAIL + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function remove(id) {
    return fetch(ROOT + DELETE_CHAIN_CATEGORY + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function createRateCategory(data) {
    return fetch(ROOT + CREATE_CHAIN_RATE_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
function updateRateCategory(data) {
    return fetch(ROOT + UPDATE_CHAIN_RATE_CATEGORY, requestOptions.post(data))
        .then(handleResponse)
        .then(data => {
            return data;
        });
}

function updateStatus(id) {
    return fetch(ROOT + RATE_CHAIN_CATEGORY_CHANGE_STATUS + `/${id}`, requestOptions.get())
        .then(handleResponse)
        .then(data => {
            return data;
        });
}
//#endregion
export const ChainCategoryService = {
    getRateCategoryList,
    remove,
    createRateCategory,
    updateRateCategory,
    getDetail,
    updateStatus
};
